/**
 * Pill — small rounded badge with optional colored dot.
 *
 * Mockup classes: .pill, .pill-{backlog,todo,doing,done,overdue}.
 * The .dot child handles the colored circle.
 */

import type { ReactNode } from "react";
import type { TaskStatus } from "@shared/types";
import { TASK_STATUS_LABEL } from "@/lib/taskStatus";

// Re-export so existing imports of `TaskStatus` from this module keep
// resolving — Pill.tsx was historically the only place it was exported
// from on the client.
export type { TaskStatus };

interface StatusPillProps {
  status: TaskStatus;
  count?: number;
}

export function StatusPill({ status, count }: StatusPillProps) {
  return (
    <span className={`pill pill-${status}`}>
      <span className="dot" />
      {TASK_STATUS_LABEL[status]}
      {count !== undefined && <span style={{ opacity: 0.6 }}>{count}</span>}
    </span>
  );
}

interface PillProps {
  variant?: "backlog" | "todo" | "doing" | "done" | "overdue";
  children: ReactNode;
  dot?: boolean;
}

export function Pill({ variant, children, dot = true }: PillProps) {
  return (
    <span className={`pill${variant ? ` pill-${variant}` : ""}`}>
      {dot && variant && <span className="dot" />}
      {children}
    </span>
  );
}
